import './application/appsignal'
import './application/turbo'

import './application/stimulus'
import './controllers'
import './lib/plausible'
import './../components'

// Altcha proof-of-work widget: registers the <altcha-widget> custom element and
// loads its German locale. English is the built-in default.
import 'altcha'
import 'altcha/i18n/de'

// Registers the <onepassword-save-button> custom element (admin MCP token page);
// without the 1Password extension it renders disabled. Turbo navigations don't
// trigger the extension's own detection, so re-announce the button on each load.
import { activateOPButton } from '@1password/save-button'
document.addEventListener('turbo:load', activateOPButton)
